import { useMemo, useState } from 'react';
import { CONNECT_INFO, WHATSAPP_LINKS, buildWhatsAppLink } from '../constants/connect';
import BackButton from '../components/BackButton';
import usePageMeta from '../hooks/usePageMeta';
import './Pages.css';

const INITIAL_FORM = {
  name: '',
  whatsapp: '',
  model: '',
  yearVersion: '',
  mileage: '',
  city: '',
  photos: '',
};

export default function SellCar() {
  const [form, setForm] = useState(INITIAL_FORM);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState({});

  usePageMeta({
    title: 'Venda seu carro com seguranca - Connect Veiculos Osasco',
    description:
      'Preencha o formulario e nossa equipe da Connect Veiculos cuida de todo o processo de venda ou consignacao com laudo e contrato.',
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const currentErrors = {};
    if (!form.name.trim()) currentErrors.name = 'Informe seu nome';
    if (!form.whatsapp.trim()) currentErrors.whatsapp = 'Informe seu WhatsApp';
    if (!form.model.trim()) currentErrors.model = 'Informe marca e modelo';
    if (!form.yearVersion.trim()) currentErrors.yearVersion = 'Informe ano e versao';
    if (!form.mileage.trim()) currentErrors.mileage = 'Informe a quilometragem';
    if (!form.city.trim()) currentErrors.city = 'Informe a cidade';
    setErrors(currentErrors);
    return Object.keys(currentErrors).length === 0;
  };

  const whatsappLink = useMemo(() => {
    const summary = [
      `Nome: ${form.name}`,
      `WhatsApp: ${form.whatsapp}`,
      `Marca/Modelo: ${form.model}`,
      `Ano/Versao: ${form.yearVersion}`,
      `KM: ${form.mileage}`,
      `Cidade: ${form.city}`,
      form.photos ? `Fotos: ${form.photos}` : null,
    ]
      .filter(Boolean)
      .join('\n');

    return buildWhatsAppLink(
      'Quero avaliar meu carro para venda ou consignacao' + (summary ? '\n\n' + summary : '')
    );
  }, [form]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!validate()) return;

    setSubmitted(true);
    window.open(whatsappLink, '_blank', 'noopener');
  };

  return (
    <div className="page-shell sellcar-page">
      <BackButton />
      <section className="page-hero" aria-labelledby="sellcar-title">
        <div className="page-hero__content">
          <h1 id="sellcar-title">Quer vender seu carro com seguranca?</h1>
          <p>
            Vendemos por voce ou fazemos proposta a vista. Sem burocracia, com laudo e contrato em cada etapa.
          </p>
          <p className="section-helper">
            Enquanto voce se decide, mantemos o carro visivel no nosso estoque proprio e tambem podemos ofertar para a rede de locadoras, ampliando as chances de uma venda rapida.
          </p>
        </div>
      </section>

      {submitted && (
        <div className="status-banner" role="status">
          Recebido! Vamos te chamar no WhatsApp ainda hoje.
        </div>
      )}

      <section className="form-card" aria-labelledby="sellcar-form-title">
        <div>
          <h2 id="sellcar-form-title">Preencha os dados do seu carro</h2>
          <p className="helper-text">
            Nossa equipe responde rapidamente pelo WhatsApp {CONNECT_INFO.whatsappE164}.
          </p>
        </div>
        <form onSubmit={handleSubmit} className="sellcar-form">
          <div className="form-grid">
            <div className="form-field">
              <label htmlFor="name">Nome *</label>
              <input
                id="name"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                aria-invalid={Boolean(errors.name)}
              />
              {errors.name && <span className="helper-text">{errors.name}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="whatsapp">WhatsApp *</label>
              <input
                id="whatsapp"
                name="whatsapp"
                value={form.whatsapp}
                onChange={handleChange}
                required
                aria-invalid={Boolean(errors.whatsapp)}
              />
              {errors.whatsapp && <span className="helper-text">{errors.whatsapp}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="model">Marca/Modelo *</label>
              <input
                id="model"
                name="model"
                value={form.model}
                onChange={handleChange}
                required
                aria-invalid={Boolean(errors.model)}
              />
              {errors.model && <span className="helper-text">{errors.model}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="yearVersion">Ano/Versao *</label>
              <input
                id="yearVersion"
                name="yearVersion"
                value={form.yearVersion}
                onChange={handleChange}
                required
                aria-invalid={Boolean(errors.yearVersion)}
              />
              {errors.yearVersion && <span className="helper-text">{errors.yearVersion}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="mileage">KM *</label>
              <input
                id="mileage"
                name="mileage"
                value={form.mileage}
                onChange={handleChange}
                required
                aria-invalid={Boolean(errors.mileage)}
              />
              {errors.mileage && <span className="helper-text">{errors.mileage}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="city">Cidade *</label>
              <input
                id="city"
                name="city"
                value={form.city}
                onChange={handleChange}
                required
                aria-invalid={Boolean(errors.city)}
              />
              {errors.city && <span className="helper-text">{errors.city}</span>}
            </div>
          </div>
          <div className="form-field">
            <label htmlFor="photos">Link de fotos (opcional)</label>
            <input
              id="photos"
              name="photos"
              value={form.photos}
              onChange={handleChange}
              placeholder="https://..."
            />
          </div>
          <div className="form-actions">
            <button type="submit" className="page-button page-button--primary">
              Enviar e abrir WhatsApp
            </button>
            <a
              className="page-button page-button--ghost"
              href={WHATSAPP_LINKS.vender}
              target="_blank"
              rel="noreferrer"
            >
              Falar direto no WhatsApp
            </a>
          </div>
        </form>
      </section>
    </div>
  );
}